import axios from './axios';

export const getTransactionsReport = async (params: any = {}) => {
  return await axios.get('/reports/transactions', { params });
};
